import BaseRepo from './BaseRepo';

const type = 'clients';

const clientsRepo = new BaseRepo(type);

export default clientsRepo;
